import { Alert, Button, Flex, Skeleton, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { CopyButton } from "@/molecules/CopyButton"
import { CodeItem } from "@/pages/IntegrationsPage/components/molecules/CodeItem"
import {
  projectGrantCommand,
  repositoryGrantCommand
} from "@/pages/IntegrationsPage/helpers/gcr"

import styles from "./GcrServiceAccount.module.scss"

import type { GcrServiceAccountProps } from "."

export const GcrServiceAccount = ({
  email,
  target,
  failed,
  onRetry
}: GcrServiceAccountProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.gcr.serviceAccount"
  })

  return (
    <Flex vertical gap={12} className={styles.serviceAccount}>
      <Text strong>{t("title")}</Text>
      <Text type="secondary">{t("description")}</Text>
      {email ? (
        <>
          <Flex align="center" gap={4}>
            <Text code>{email}</Text>
            <CopyButton text={email} type="link" />
          </Flex>
          <CodeItem
            withCopy
            titleLine1={t("repositoryCommand")}
            codeSnippet={repositoryGrantCommand(email, target)}
          />
          <CodeItem
            withCopy
            titleLine1={t("projectCommand")}
            codeSnippet={projectGrantCommand(email, target)}
          />
        </>
      ) : failed ? (
        <Alert
          showIcon
          type="error"
          title={t("failed")}
          action={
            <Button size="small" onClick={onRetry}>
              {t("retry")}
            </Button>
          }
        />
      ) : (
        <Flex vertical gap={4}>
          <Text type="secondary">{t("loading")}</Text>
          <Skeleton.Input active size="small" />
        </Flex>
      )}
    </Flex>
  )
}
